var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldBrush2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.37 4.79c-.1-.79-.39-1.42-.85-1.89-.6-.6-1.47-.9-2.59-.9H7.35C5.1 2 3.86 3.24 3.86 5.49c0 1.12.3 1.99.9 2.59.6.6 1.47.9 2.59.9h5.58c2 0 3.2-.99 3.44-2.79h.28c2.09 0 2.09.28 2.09 2.09v1.86c0 1.81 0 2.09-2.09 2.09h-3.72c-2.99 0-3.42 1.42-3.48 2.8-.9.06-1.87.48-1.87 2.08v2.79c0 1.73 1.14 2.09 2.09 2.09h.93c.95 0 2.09-.36 2.09-2.09v-2.79c0-1.58-.95-2.02-1.85-2.08.05-1.01.34-1.41 2.08-1.41h3.72c3.25 0 3.49-1.32 3.49-3.49V8.28c.01-2.17-.23-3.49-3.48-3.49h-.28z",
    fill: "{props.color}",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBrush2);
export default __webpack_public_path__ + "static/media/vuesax-bold-brush_2.9dba5331083ca3c37b0f68b6576b542f.svg";
export { ForwardRef as ReactComponent };